import { UserInfo } from '@Entities/user/user'

// this function is used for analytics and should not break, so it handles an optional UserInfo even though UserInfo should always be present before analytics are sent to User Pilot
const userPilotUserContext = (userInfo?: UserInfo) => {
    if (!userInfo) {
        return {}
    }
    const name = userInfo.firstName + ' ' + userInfo.lastName
    return {
        name: name,
        email: userInfo.email,
        created_at: userInfo.invitedAt,
    }
}

export default userPilotUserContext
